import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ThesisDetailsComponent} from './thesis-details.component';

const routes: Routes = [
  {path: 'theses/details', component: ThesisDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class ThesisDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-details/thesis-details-routing.module.ts